export default {
  path: '/file',
  name: 'file',
  redirect: { name: 'file.list-page' },
  component: () =>
    import(/* webpackChunkName: "file" */ '@/views/file/index.vue'),
  children: [
    {
      path: '/file',
      name: 'file.list-page',
      component: () =>
        import(
          /* webpackChunkName: "new-file-page" */ '@/views/file/FilesPage.vue'
        )
    },
    {
      path: '/file/create',
      name: 'file.new-page',
      component: () =>
        import(
          /* webpackChunkName: "new-file-page" */ '@/views/file/NewFilePage.vue'
        )
    },
    {
      path: '/file/:id/success',
      name: 'file.success-page',
      component: () =>
        import(
          /* webpackChunkName: "success-page" */ '@/views/file/SuccessPage.vue'
        )
    },
    {
      path: '/file/:id',
      name: 'file.view-page',
      component: () =>
        import(
          /* webpackChunkName: "success-page" */ '@/views/file/ViewFilePage.vue'
        )
    },
    {
      path: '/file/:id/edit',
      name: 'file.edit-page',
      component: () =>
        import(
          /* webpackChunkName: "success-page" */ '@/views/file/EditFilePage.vue'
        )
    }
  ]
}
